import script from "./delete_modal.vue?vue&type=script&setup=true&lang=js"
export * from "./delete_modal.vue?vue&type=script&setup=true&lang=js"

import "./delete_modal.vue?vue&type=style&index=0&id=62622fb2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62622fb2"]])

export default __exports__